module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[40]527.cc19f01.woff2";